var map = {
	"./basketball.webp": 1664,
	"./bti-img.webp": 1665,
	"./bti-title-en.webp": 1666,
	"./cup.webp": 1667,
	"./football.webp": 1668,
	"./im-img.webp": 1669,
	"./im-title-en.webp": 1670,
	"./imone-img.webp": 1671,
	"./imone-title-en.webp": 1672,
	"./sb-img.webp": 1673,
	"./sb-title-cn.webp": 1674,
	"./sb-title-en.webp": 1675,
	"./sbo-img.webp": 1676,
	"./sbo-title-cn.webp": 1677,
	"./sbo-title-en.webp": 1678,
	"./sport-bg.webp": 1679,
	"./sport-ctg.webp": 1680,
	"./title-cn.webp": 1681,
	"./title-en.webp": 1682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;